// @flow
import { useCallback } from 'react';
import moment from 'moment-timezone';

import { api } from 'app/api';
import { formats } from 'app/common/api/requests/reports/generate_file';
import { POST_REPORTS_PERFORM_FINANCES_BY_CUSTOMER, reportTypes, dateFormat } from 'app/common/api/requests/reports/perform';
import { GET_DOWNLOAD_FILE } from 'app/common/api/requests/reports/download_file';
import { GET_REPORTS_STATUS } from 'app/common/api/requests/reports/status';


type Handlers = {
  onProcessRequest: () => Promise<number | string | null>,
  onProcessCheckStatus: (reportId: number) => Promise<number | string>,
  onFileDownload: (reportId: number) => Promise<void>,
}

type Params = {
  personId: number,
  date: string,
  schoolId?: number,
}

export default function useGenerateFileRequests({
  personId,
  date,
  schoolId,
}: Params, filename: string): Handlers {
  const onProcessRequest = useCallback(async () => {
    const error = 'Не удалось запустить генерацию файла отчета';
    const res = await api.request(POST_REPORTS_PERFORM_FINANCES_BY_CUSTOMER, {
      error,
      params: {
        report_type: reportTypes.FINANCES_BY_CUSTOMER,
        report_format: formats.XLSX,
        params: {
          account_id: personId,
          from_date: moment(date).startOf('month').format(dateFormat),
          to_date: moment(date).endOf('month').format(dateFormat),
          school_id: schoolId,
          for_camp: !!schoolId,
        },
      },
    });
    if (res) {
      return res;
    }
    return error;
  }, [personId, date, schoolId]);

  const onProcessCheckStatus = useCallback(async (reportId_: number) => {
    const error = 'Не удалось получить статус генерации файла';
    const res = await api.request(GET_REPORTS_STATUS, {
      error,
      params: {
        report_id: reportId_,
      },
    });

    if (typeof res === 'number') {
      return res;
    }
    return error;
  }, []);

  const onFileDownload = useCallback(async (reportId_: number) => {
    await api.download(GET_DOWNLOAD_FILE, {
      error: 'Не удалось загрузить файл',
      filename: `${filename}.${formats.XLSX}`,
      params: {
        report_id: reportId_,
      },
    });
  }, [filename]);

  return {
    onProcessRequest,
    onProcessCheckStatus,
    onFileDownload,
  };
}
